import { X } from "lucide-react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type { AiScriptChatSelectionContext } from "@/payroll/ai-script/types";
import {
  formatSelectionContextChip,
  formatSelectionContextTitle,
} from "./selection-context";

interface SelectionContextChipProps {
  context: AiScriptChatSelectionContext;
  onDismiss?: () => void;
}

export const SelectionContextChip = ({
  context,
  onDismiss,
}: SelectionContextChipProps) => (
  <Stack
    direction="row"
    align="center"
    className="inline-flex max-w-full gap-1.5 rounded-md border border-stroke-tertiary bg-bg-secondary px-2 py-1 text-sm text-secondary-text"
  >
    <Typography
      variant="captionW1SemiBold"
      textColor="tertiary"
      className="shrink-0"
    >
      {formatSelectionContextTitle(context)}
    </Typography>
    <span className="truncate">{formatSelectionContextChip(context)}</span>
    {onDismiss && (
      <button
        type="button"
        aria-label="Remove selection context"
        onClick={onDismiss}
        className="shrink-0 text-tertiary-text transition-colors hover:text-secondary-text"
      >
        <X className="h-3 w-3" />
      </button>
    )}
  </Stack>
);
